// ID ПИК
export const DEVELOPER_ID = 9;
export const DEVELOPER_NAME = 'ПИК';
export const DEVELOPER_REALTY_USER_ID = 7731814;
